import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'cat-sub-grade-drpdn',
})

export default class CatSubGradeDropdown extends Vue {
    @Prop()
    private isWithFw: any;

    @Prop()
    private isWithGrades: any;

    @Prop()
    private bindData: any;

    @Prop()
    private isShowAll: any;

    @Prop()
    private isShowAddButton: any;

    private content: any = {};

    private cateogryOptions: any = {};

    private cateogrySubjectFWGrade: any = {
        categories: {
            label: 'Cateogry',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            event: {
                change: this.onChangeCategories,
            },
        },
        subjects: {
            label: 'Subjects',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            event: {
                change: this.onSelectSubject,
            },
        },
        frameworks: {
            label: 'Frameworks',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'taxonomy_subject_id',
            },
            event: {
                change: this.onChangeFramework,
            },
        },
        grades: {
            label: 'Grades',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'grade',
                'value-field': 'id',
            },
            event: {
                change: this.onChangeGrades,
            },
        },
    };

    private cateogrySubjectFW: any = {
        categories: {
            label: 'Cateogry',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            event: {
                change: this.onChangeCategories,
            },
        },
        subjects: {
            label: 'Subjects',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            event: {
                change: this.onSelectSubject,
            },
        },
        frameworks: {
            label: 'Frameworks',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'taxonomy_subject_id',
            },
            event: {
                change: this.onChangeFramework,
            },
        },
    };

    private cateogrySubjectGrade: any = {
        categories: {
            label: 'Cateogry',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            event: {
                change: this.onChangeCategories,
            },
        },
        subjects: {
            label: 'Subjects',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            event: {
                change: this.onSelectSubjectForGrdaes,
            },
        },
        grades: {
            label: 'Grades',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'code',
            },
            event: {
                change: this.onChangeGrades,
            },
        },
    };

    private cateogrySubjectOnly: any = {
        categories: {
            label: 'Cateogry',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            event: {
                change: this.onChangeCategories,
            },
        },
        subjects: {
            label: 'Subjects',
            items: [],
            selectedItems: [],
            options: {
                'text-field': 'title',
                'value-field': 'id',
            },
            event: {
                change: this.onSelectSubject,
            },
        },
    };

    // ---------------------------------------------------------------------
    // Methods

    public fetchCategoryList() {
        const contentDetails = this.cateogryOptions;
        taxonomyAPI.fetchTaxonomyClassifications().then((categoryList: any) => {
            const { categories } = contentDetails;
            categories.items = categoryList;
            if (this.bindData) {
                categories.selectedItems = this.extractCategoryDetails(this.bindData, categoryList);
            }
        });
    }

    public getSubjectList(categoryId: string) {
        const contentDetails = this.cateogryOptions;
        taxonomyAPI.fetchSubjects(categoryId).then((subjectList: any) => {
            const { subjects } = contentDetails;
            subjects.items = subjectList;
            if (this.bindData) {
                subjects.selectedItems = this.extractSubjectDetails(this.bindData, subjectList);
            }
        });
    }

    // -------------------------------------------------------------------
    // Hooks

    private created() {
        this.cateogryOptions = this.cateogrySubjectOnly;
        if (this.isWithFw && this.isWithGrades) {
            this.cateogryOptions = this.cateogrySubjectFWGrade;
        } else if (this.isWithFw) {
            this.cateogryOptions = this.cateogrySubjectFW;
        } else if (this.isWithGrades) {
            this.cateogryOptions = this.cateogrySubjectGrade;
        }
        this.fetchCategoryList();
    }

    // ---------------------------------------------------------------------
    // Actions

    private onChangeCategories(categoryId: any) {
        this.cateogryOptions.subjects.selectedItems = [];
        if (this.cateogryOptions.frameworks) {
            this.cateogryOptions.frameworks.selectedItems = [];
        }
        if (this.cateogryOptions.grades) {
            this.cateogryOptions.grades.selectedItems = [];
        }
        this.getSubjectList(categoryId);
    }

    private onSelectSubject(subjectId: any) {
        const cateogryOptions = this.cateogryOptions;
        if (this.cateogryOptions.frameworks) {
            this.cateogryOptions.frameworks.selectedItems = [];
        }
        if (this.cateogryOptions.grades) {
            this.cateogryOptions.grades.selectedItems = [];
        }
        if (this.isWithFw) {
            const { frameworks, subjects } = cateogryOptions;
            const activeSubject = subjects.items.find((subject: any) => subject.id === subjectId);
            frameworks.items = activeSubject ? activeSubject.frameworks : [];
            if (this.bindData) {
                frameworks.selectedItems = this.extractFWDetails(frameworks.items);
            }
        }

        if (this.isWithGrades && this.isWithFw) {
            if (this.cateogryOptions.grades) {
                this.cateogryOptions.grades.selectedItems = [];
            }
        } else if (this.isWithGrades) {
            this.onSelectSubjectForGrdaes(subjectId);
        }
        this.$emit('updateCatSub', this.cateogryOptions);
    }

    private onSelectSubjectForGrdaes(subjectId: any) {
        const cateogryOptions = this.cateogryOptions;
        const { grades, subjects } = cateogryOptions;
        const activeSubject = subjects.items.find((subject: any) => subject.id === subjectId);
        taxonomyAPI.fetchTaxonomyGrades(activeSubject.id, 'GUT').then((courses) => {
            grades.items = courses ? courses : [];
        });
    }


    private onSelectSubjectForGrdaesWithFWCode(subjectId: any, fwCode: any) {
        const cateogryOptions = this.cateogryOptions;
        const { grades, subjects } = cateogryOptions;
        taxonomyAPI.fetchTaxonomyGradesWithFwCode(subjectId, fwCode).then((courses) => {
            grades.items = courses ? courses : [];
        });
    }

    private extractCategoryDetails(data: any, categoryList: any) {
        let propName: any;
        for (const prop in data) {
            if (data.hasOwnProperty(prop)) {
                propName = prop;
            }
        }
        const dataSplit = propName.split('.');
        for (const iterator of categoryList) {
            if (iterator.code === dataSplit[1]) {
                this.getSubjectList(iterator.id);
                return iterator.id;
            }
        }
    }

    private extractSubjectDetails(data: any, subjectList: any) {
        let propName: any;
        for (const prop in data) {
            if (data.hasOwnProperty(prop)) {
                propName = prop;
            }
        }
        const dataSplit = propName.split('.');
        for (const iterator of subjectList) {
            if (iterator.id === `${dataSplit[1]}.${dataSplit[2]}`) {
                this.onSelectSubject(iterator.id);
                return iterator.id;
            }
        }
    }

    private extractFWDetails(fwList: any) {
        let fwDetails: any;
        for (const key in this.bindData) {
            if (this.bindData.hasOwnProperty(key)) {
                fwDetails = key;
            }
        }
        for (const iterator of fwList) {
            if (iterator.taxonomy_subject_id === fwDetails) {
                return iterator.taxonomy_subject_id;
            }
        }
    }

    private onChangeGrades() {
        this.$emit('updateCatSub', this.cateogryOptions);
    }

    private onChangeFramework() {
        if (this.isWithGrades && this.isWithFw) {
            const subjectId = this.cateogryOptions.subjects.selectedItems;
            if (this.cateogryOptions.frameworks && this.cateogryOptions.frameworks.selectedItems && subjectId) {
                const fw = this.cateogryOptions.frameworks.selectedItems.split('.');
                this.onSelectSubjectForGrdaesWithFWCode(subjectId, fw[0]);
            }
        }
        this.$emit('updateCatSub', this.cateogryOptions);
    }

    private onAddSelection() {
        const sendItem: any = this.cateogryOptions;
        this.$emit('onAddSelection', sendItem);
        setTimeout(() => {
            this.clearAllSelectedData();
        }, 50);
    }

    private clearAllSelectedData() {
        this.cateogryOptions.categories.selectedItems = [];
        this.cateogryOptions.subjects.selectedItems = [];
        if (this.cateogryOptions.frameworks) {
            this.cateogryOptions.frameworks.selectedItems = [];
        }
        if (this.cateogryOptions.grades) {
            this.cateogryOptions.grades.selectedItems = [];
        }
    }

}
